<div class="organisation-item">
    <!-- <img class="recipe-img" src="/assets/pictos/recipes/{{recipe.picto!}}.svg" alt={{recipe.title!}}> -->
    <p>{{organisationItem}}</p> 
</div>
